import React, { useEffect, useState } from "react";
import { db } from "../firebase"; 
import { collection, query, orderBy, onSnapshot } from "firebase/firestore";
import { Link } from "react-router-dom";

// IMPORT DES DONNÉES EXISTANTES
import { articles as localArticles } from "../data/articles"; 
import { blogs as localBlogs } from "../data/blogs";

function Blog() {
  const [firebaseArticles, setFirebaseArticles] = useState([]);

  // 1. RÉCUPÉRATION DES ARTICLES IA (Firebase)
  useEffect(() => {
    const q = query(collection(db, "articles"), orderBy("date", "desc"));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      setFirebaseArticles(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });
    return () => unsubscribe();
  }, []);

  // 2. FUSION DE TOUTES LES SOURCES
  // On met les articles Firebase en premier, puis tes 3 articles de base, puis tes 5 fiches PNG
  const allPosts = [...firebaseArticles, ...localArticles, ...localBlogs];

  return (
    <main className="container-fluid" style={{ paddingTop: '100px', minHeight: '100vh', background: '#0f0f1b' }}>
      <h2 className="section-title" style={{ color: '#00ffcc', textAlign: 'center' }}>Blog / Articles & Analyses</h2>
      
      <div className="standard-grid" style={styles.grid}>
        {allPosts.map((post, index) => (
          <div key={post.id || index} className="game-card" style={styles.card}>
            <img 
              src={post.image} 
              alt={post.title} 
              style={styles.image} 
            />
            <div style={{ padding: '15px' }}>
              <span style={styles.badge}>{post.category || "NEWS"}</span>
              <h3 style={styles.postTitle}>{post.title}</h3>
              
              {/* Le lien s'adapte : /article/ pour les textes et /blog/ pour tes fiches PNG */}
              <Link 
                to={post.id > 100 ? `/blog/${post.id}` : `/article/${post.slug}`} 
                className="btn-primary" 
                style={styles.button}
              >
                Lire l'article
              </Link>
            </div>
          </div>
        ))}
      </div>
    </main>
  );
}

const styles = {
  grid: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: "25px", padding: "20px" },
  card: { background: "#1a1b26", borderRadius: "15px", border: "1px solid #333", overflow: "hidden" },
  image: { width: '100%', height: '200px', objectFit: 'cover' },
  badge: { color: '#ec008c', fontSize: '0.7rem', fontWeight: 'bold', textTransform: 'uppercase' },
  postTitle: { fontSize: '1.1rem', margin: '10px 0', color: '#fff', height: '2.4em', overflow: 'hidden' },
  button: { fontSize: '0.8rem', display: 'inline-block', marginTop: '10px', color: '#00ffcc', textDecoration: 'none', fontWeight: 'bold', border: '1px solid #00ffcc', padding: '5px 10px', borderRadius: '5px' }
};

export default Blog;